import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-6 text-center py-20">
      <h1 className="text-6xl font-bold tracking-tight">404</h1>
      <h2 className="text-2xl font-semibold">{t("notFound.title")}</h2>
      <p className="text-muted-foreground max-w-[400px]">
        {t("notFound.description")}
      </p>
      <Button asChild>
        <Link to="/">{t("notFound.backToHome")}</Link>
      </Button>
    </div>
  );
}
